import {
    BundleComponent,
    GaEcommerceItem,
    IGa4AddToCart,
    IGa4ReviewOrderSummary,
    IGa4ViewItem,
    OrderProductItem,
} from "../interfaces/ga4-event.interface";

export class Ga4EventService {
    private fireEvent(event: string, data: any) {
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: event,
            ecommerce: data,
        });
    }

    public getProductItems(): GaEcommerceItem[] {
        const items: GaEcommerceItem[] = [];
        const tcVars = window.tc_vars;
        const price = Array.isArray(tcVars.product_unitprice_ati) ? tcVars.product_unitprice_ati[0] : tcVars.product_unitprice_ati;
        if(tcVars.product_is_bundle === '1') {
            items.push({
                item_id: tcVars.product_id,
                item_name: tcVars.product_name,
                item_list_name: '',
                index: 0,
                item_brand: '',
                item_category: '',
                item_category2: '',
                item_category3: '',
                item_category4: '',
                bundle_id: tcVars.product_bundle_id,
                bundle_name: tcVars.product_bundle_name,
                price: parseFloat(price),
                currency: tcVars.product_currency,
                discount: Number(
                    (parseFloat(tcVars.product_unitprice_ati) - parseFloat(tcVars.product_unitprice_tf)).toFixed(2)
                ),
                quantity: 1,
                is_bundle: true
            });
            tcVars.product_bundle_components.forEach((obj: BundleComponent)=>{
                items.push({
                    item_id: obj.product_id,
                    item_name: obj.product_name,
                    index: parseInt(obj.product_bundle_component_sort),
                    item_brand: obj.product_trademark,
                    item_category: obj.product_cat1,
                    item_category2: obj.product_cat2,
                    item_category3: obj.product_cat3,
                    item_category4: obj.product_cat4,
                    bundle_id: obj.product_bundle_id,
                    bundle_name: obj.product_bundle_name,
                    price: parseFloat(obj.product_unitprice_ati),
                    currency: tcVars.product_currency,
                    discount: Number(
                        (parseFloat(obj.product_unitprice_ati) - parseFloat(obj.product_unitprice_tf)).toFixed(2)
                    ),
                    quantity: parseInt(obj.product_quantity),
                    is_bundle_component: obj.product_is_bundle_component === '1',
                    is_bundle_main_component: obj.product_is_bundle_main_component === '1'
                });
            })
        }
        else {
            items.push({
                item_id: tcVars.product_id,
                item_name: tcVars.product_name,
                item_list_name: '',
                index: 0,
                item_brand: tcVars.product_trademark,
                item_category: tcVars.product_cat1,
                item_category2: tcVars.product_cat2,
                item_category3: tcVars.product_cat3,
                item_category4: tcVars.product_cat4,
                price: parseFloat(price),
                currency: tcVars.product_currency,
                discount: Number(
                    (parseFloat(tcVars.product_unitprice_ati) - parseFloat(tcVars.product_unitprice_tf)).toFixed(2)
                ),
                quantity: 1
            });
        }
        return items;
    }

    public getOrderProducts(): GaEcommerceItem[] {
        const items: GaEcommerceItem[] = [];
        const tcVars = window.tc_vars;
        if (!(tcVars.order_products?.length > 0)) {
            return items;
        }

        let index = 0;
        return tcVars.order_products.map((obj: OrderProductItem): GaEcommerceItem => ({
               item_id: obj.order_product_id,
               item_name: obj.order_product_name,
               index: index++,
               item_brand: obj.order_product_trademark,
               item_category: obj.order_product_cat1,
               item_category2: obj.order_product_cat2,
               item_category3: obj.order_product_cat3,
               item_category4: obj.order_product_cat4,
               price: parseFloat(obj.order_product_unitprice_ati),
               quantity: parseInt(obj.order_product_quantity),
               bundle_id: obj.order_product_bundle_id,
               bundle_name: obj.order_product_bundle_name,
               is_bundle_component: obj.order_product_is_bundle_component === '1',
               is_bundle: obj.order_product_is_bundle === '1',
               is_bundle_main_component: obj.order_product_is_bundle_main_component === '1'
        }));
    }

    public addToCart(data: IGa4AddToCart) {
        this.fireEvent('con_add_to_cart', data);
    }

    public viewItem(data: IGa4ViewItem) {
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'con_view_item',
            ecommerce: data.ecommerce,
            is_from_bundle_banner_sku: data.is_from_bundle_banner_sku,
            is_from_bundle_page_sku: data.is_from_bundle_page_sku,
        });
    }

    public reviewOrderSummary(data: IGa4ReviewOrderSummary) {
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({
            event: 'con_review_order_summary',
            payment_type: data.payment_type,
            currency: data.currency,
            value: data.value,
        });
    }

    public algoliaAddedToCartObjectIdsAfterSearch() {
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({
            event: 'algolia_added_to_cart_object_ids_after_search',
        });
    }

    public algoliaAddedToCartObjectIds() {
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({
            event: 'algolia_added_to_cart_object_ids',
        });
    }
}

export const ga4EventService = new Ga4EventService();
